import { activityShop, ringCentre, type PulsePlace, type PulseShop } from '#lib/footfall/pulse';
import { activityColour } from '#lib/footfall/activity';
import type { PulseMapActivity, PulseTrafficView } from '#types/types';

/** All captured places, including neighbours and records without charts; unit links require recorded identity. */
export function recordedMapping(shops: PulseShop[], places: PulsePlace[], activity: Record<string, PulseMapActivity>, view: PulseTrafficView) {
  const rows = shops.map(shop => {
    const unitIds = places.filter(place => shop.activityUnits?.some(link => link.id === place.feature.id)
      && activityShop(place.feature.name, shops, place.feature.id) === shop
      && activityShop(place.name, shops, place.feature.id) === shop).map(place => place.feature.id);
    const percent = shop.activity?.days.find(day => day.day === view.day)?.hours.find(hour => hour.hour === view.hour)?.percent ?? null;
    const p = shop.location;
    const location = p && Number.isFinite(p.lng) && Math.abs(p.lng) <= 180 && Number.isFinite(p.lat) && Math.abs(p.lat) <= 90 ? p : null;
    const identity = shop.placeId ?? JSON.stringify([shop.name, location?.lng, location?.lat]);
    return { id: `place-${identity}`, shop, unitIds, percent, location };
  });
  const units = places.map(place => ({ id: `unit-${place.feature.id}`, place, location: ringCentre(place.feature.rings), observation: activity[place.feature.id] ?? null }));
  return { rows, units, profiles: rows.filter(row => row.shop.activity).length, linkedProfiles: rows.filter(row => row.shop.activity && row.unitIds.length).length, located: rows.filter(row => row.location).length };
}

/** Geographic observations are separate points; neither their floor nor a tenant polygon is inferred. */
export function recordedPlacePoints(rows: ReturnType<typeof recordedMapping>['rows'], all: boolean) {
  return { type: 'FeatureCollection' as const, features: rows.flatMap(row => row.location && (all || (row.shop.activity && !row.unitIds.length)) ? [{
    type: 'Feature' as const,
    properties: { id: row.id, placeId: row.shop.placeId ?? null, name: row.shop.name, percent: row.percent, colour: row.percent === null ? '#8E8E8E' : activityColour(row.percent) },
    geometry: { type: 'Point' as const, coordinates: [row.location.lng, row.location.lat] },
  }] : []) };
}
